import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function TransformationSection() {
  const {
    lang
  } = useLanguage();
  const shifts = [{
    from: 'Una presencia genérica que no transmite quién eres.',
    fromEn: "A generic presence that doesn't convey who you are.",
    to: 'Una identidad digital que comunica tu valor antes de hablar.',
    toEn: 'A digital identity that communicates your value before you speak.'
  }, {
    from: 'Improvisar sin sistema ni dirección clara.',
    fromEn: 'Improvising without a system or clear direction.',
    to: 'Un negocio con estrategia, claridad y propósito.',
    toEn: 'A business with strategy, clarity, and purpose.'
  }, {
    from: 'Atraer a las personas equivocadas.',
    fromEn: 'Attracting the wrong people.',
    to: 'Atraer a los clientes que realmente valoran lo que haces.',
    toEn: 'Attracting the clients who truly value what you do.'
  }];
  const delays = [0, 0.12, 0.18];
  return <section id="transformacion" className="py-16 lg:py-[100px] bg-[#FAF8F5]" data-id="element-472" data-mp="f9rd6zrqa9jd">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-473" data-mp="k2kibor3zjvz">
        {/* ─────────────── HEADER ─────────────── */}
        <div className="text-center mb-12 lg:mb-16 max-w-2xl mx-auto" data-id="element-474" data-mp="5epr6csr1nl0">
          <span className="block font-sans text-[10px] font-bold tracking-[3px] uppercase text-[#5A4579] mb-6 lg:mb-8" data-id="element-475" data-mp="ad0zuk7b5s1n">
            {lang === 'es' ? 'LA TRANSFORMACIÓN' : 'THE TRANSFORMATION'}
          </span>
          <h2 className="font-display text-[28px] sm:text-[4vw] lg:text-[48px] leading-[1.1] tracking-[-0.5px] text-[#1A1A2E]" data-id="element-476" data-mp="12zc2e0eh6313">
            {lang === 'es' ? <>
                De donde estás, a donde{' '}
                <em className="italic text-[#5A4579]" data-id="element-477" data-mp="t4k40ud2jc59">mereces</em> estar.
              </> : <>
                From where you are, to where you{' '}
                <em className="italic text-[#5A4579]" data-id="element-478" data-mp="3du9hb2y4ipvu">deserve</em> to be.
              </>}
          </h2>
        </div>

        {/* ─────────────── SPLIT BEFORE/AFTER CARDS ─────────────── */}
        <div className="flex flex-col gap-3 lg:gap-4 max-w-[720px] mx-auto" data-id="element-479" data-mp="1fbeekbyw2zzl">
          {shifts.map((shift, index) => <div key={index} className="group grid grid-cols-2 rounded-[12px] lg:rounded-[16px] overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.08)] transition-all duration-200 ease-in-out hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(0,0,0,0.12)]" data-id="element-480" data-mp="1ahtdgb201pw6" data-mpi={index}>
              {/* LEFT — ANTES */}
              <motion.div initial={{
            opacity: 0,
            x: -16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            ease: 'easeOut',
            delay: delays[index]
          }} className="relative overflow-hidden bg-[#F5F5F5] border-r border-[rgba(90,69,121,0.15)] p-[18px] lg:p-6" data-id="element-481" data-mp="rks82p4j9nrp">
                <span aria-hidden="true" className="pointer-events-none select-none absolute -bottom-4 right-1 text-[80px] leading-none font-serif text-black/[0.06]" data-id="element-482" data-mp="2y92dm9lmetjv">
                  ✕
                </span>
                <div className="relative z-10" data-id="element-483" data-mp="26kr11tk7mws8">
                  <span className="block font-sans text-[9px] font-bold tracking-[3px] uppercase text-[#9CA3AF] mb-3" data-id="element-484" data-mp="2al17f7bwzp7m">
                    {lang === 'es' ? 'ANTES' : 'BEFORE'}
                  </span>
                  <p className="text-[13px] lg:text-[14px] text-[#9CA3AF] leading-[1.6]" data-id="element-485" data-mp="2kj75teyiid7q">
                    {lang === 'es' ? shift.from : shift.fromEn}
                  </p>
                </div>
              </motion.div>

              {/* RIGHT — CON INKOVA */}
              <motion.div initial={{
            opacity: 0,
            x: 16
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            ease: 'easeOut',
            delay: delays[index]
          }} className="relative overflow-hidden p-[18px] lg:p-6 bg-[linear-gradient(135deg,#3D2F5A,#5A4579)] transition-all duration-200 group-hover:brightness-110" data-id="element-486" data-mp="18olpraym4b39">
                <span aria-hidden="true" className="pointer-events-none select-none absolute -bottom-4 right-1 text-[80px] leading-none font-serif text-white/[0.08]" data-id="element-487" data-mp="20fjgwalbznmm">
                  ✓
                </span>
                <div className="relative z-10" data-id="element-488" data-mp="25fnwzzibugcb">
                  <span className="block font-sans text-[9px] font-bold tracking-[3px] uppercase text-white/60 mb-3" data-id="element-489" data-mp="25gz160fopq3y">
                    {lang === 'es' ? 'CON INKOVA' : 'WITH INKOVA'}
                  </span>
                  <p className="flex items-start gap-2 text-[13px] lg:text-[14px] text-white leading-[1.6]" data-id="element-490" data-mp="2txy1879187w5">
                    <span className="text-[16px] leading-[1.3] text-[#A78BCA] shrink-0" data-id="element-491" data-mp="2f54f42z98tii">
                      ✓
                    </span>
                    <span data-id="element-492" data-mp="269ew20la4b8a">{lang === 'es' ? shift.to : shift.toEn}</span>
                  </p>
                </div>
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}